import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageLanzarote = props => {
  return <CityLandingPage cityKey="Lanzarote" cityConfig={cityContent.lanzarote} {...props} />;
};

export default LandingPageLanzarote;
